/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TransferBatchesControllerListBatchesQueryResponse, TransferBatchesControllerListBatchesQueryParams, TransferBatchesControllerListBatches401, TransferBatchesControllerListBatches403 } from "../../models/transferBatchesController/TransferBatchesControllerListBatches";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { transferBatchesControllerListBatches } from "../../clients/transfer-batchesService/transferBatchesControllerListBatches";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const transferBatchesControllerListBatchesQueryKey = (params: TransferBatchesControllerListBatchesQueryParams = {}) => [{
  url: '/api/v1/transfer-batches'
}, ...(params ? [params] : [])] as const;
export type TransferBatchesControllerListBatchesQueryKey = ReturnType<typeof transferBatchesControllerListBatchesQueryKey>;
export function transferBatchesControllerListBatchesQueryOptions(params?: TransferBatchesControllerListBatchesQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = transferBatchesControllerListBatchesQueryKey(params);
  return queryOptions<TransferBatchesControllerListBatchesQueryResponse, ResponseErrorConfig<TransferBatchesControllerListBatches401 | TransferBatchesControllerListBatches403>, TransferBatchesControllerListBatchesQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return transferBatchesControllerListBatches(params, config);
    }
  });
}

/**
 * @summary List all transfer batches
 * {@link /api/v1/transfer-batches}
 */
export function useTransferBatchesControllerListBatches<TData = TransferBatchesControllerListBatchesQueryResponse, TQueryData = TransferBatchesControllerListBatchesQueryResponse, TQueryKey extends QueryKey = TransferBatchesControllerListBatchesQueryKey>(params?: TransferBatchesControllerListBatchesQueryParams, options: {
  query?: Partial<QueryObserverOptions<TransferBatchesControllerListBatchesQueryResponse, ResponseErrorConfig<TransferBatchesControllerListBatches401 | TransferBatchesControllerListBatches403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? transferBatchesControllerListBatchesQueryKey(params);
  const query = useQuery({
    ...transferBatchesControllerListBatchesQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<TransferBatchesControllerListBatches401 | TransferBatchesControllerListBatches403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}